import { GetterTree } from 'vuex';
import { DashboardState, RootState } from '../types';

export const getters: GetterTree<DashboardState, RootState> = {
	getCalendarEvents: (state): CalendarEvent[] => {
		return state.calendarEvents;
	},

	getPendingOrders: (state): DashboardOrder[] => {
		return state.pendingOrders;
	},

	getPendingOrdersCount: (state): number => {
		return state.pendingOrdersCount;
	},

	getQuotes: (state): DashboardQuoteOrder[] => {
		return state.quotes;
	},

	getQuotesCount: (state): number => {
		return state.quotesCount;
	},

	getPendingOrderSort(state): string {
		return state.pendingOrdersSort;
	},

	getOrdersSummary(state): OrdersSummaryType {
		return state.ordersSummary;
	},

	getFilters(state): DashboardFilters {
		return state.filters;
	},

	getCalendarType(state): 'month' | 'week' | 'day' {
		return state.calendarType;
	},

	getInquiriesSummary(state): DashboardInquiriesSummary | null {
		return state.inquiriesSummary;
	}
};